import Objects from "./Objects.js";
class ObjectFieldHelp{
	static load(id, callback){
		Objects.load(callback, ObjectFieldHelp.API_ENDPOINT + id);
	}
}
ObjectFieldHelp.API_ENDPOINT = '/api/ObjectFieldHelp/';
export default ObjectFieldHelp;